import { Box } from "@mui/material";
import { FC } from "react";
import { CalendarViewProps } from "../types";
import { overWriteStartDate } from "../utils";
import { YearsGrid } from "./YearsGrid";

const START_YEAR = 2024;

export const YearsView: FC<CalendarViewProps> = ({
  tempStartDate,
  tempEndDate,
  setTempStartDate,
  setTempEndDate,
  earliestSelectableDate,
}) => {
  const handleYearSelect = (year: number) => {
    const chosenYearStartDate = new Date(Date.UTC(year, 0, 1));
    const yearEndDate = new Date(Date.UTC(year, 11, 31));

    const yearStartDate = overWriteStartDate(
      chosenYearStartDate,
      earliestSelectableDate,
    );

    if (!tempStartDate || tempEndDate) {
      setTempStartDate(yearStartDate);
      setTempEndDate(null);
    } else {
      const startTime = tempStartDate.getTime();
      const selectedTime = yearStartDate.getTime();

      if (selectedTime >= startTime) {
        setTempEndDate(yearEndDate);
      } else {
        setTempStartDate(yearStartDate);
        setTempEndDate(null);
      }
    }
  };

  return (
    <Box>
      <YearsGrid
        earliestStartYear={START_YEAR}
        endDate={tempEndDate}
        onYearSelect={handleYearSelect}
        startDate={tempStartDate}
      />
    </Box>
  );
};
